import * as React from 'react';

function IconStatusInfoMedium(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M12 3C10.22 3 8.47991 3.52784 6.99987 4.51677C5.51983 5.50571 4.36627 6.91131 3.68508 8.55585C3.0039 10.2004 2.82567 12.01 3.17293 13.7558C3.5202 15.5016 4.37737 17.1053 5.63604 18.364C6.89471 19.6226 8.49836 20.4798 10.2442 20.8271C11.99 21.1743 13.7996 20.9961 15.4442 20.3149C17.0887 19.6337 18.4943 18.4802 19.4832 17.0001C20.4722 15.5201 21 13.78 21 12C21 9.61305 20.0518 7.32387 18.364 5.63604C16.6761 3.94821 14.3869 3 12 3ZM13.5 18H10.5V12H9V10.5H13.5V18ZM12 9C11.7033 9 11.4133 8.91203 11.1666 8.7472C10.92 8.58238 10.7277 8.34811 10.6142 8.07403C10.5006 7.79994 10.4709 7.49834 10.5288 7.20736C10.5867 6.91639 10.7296 6.64912 10.9393 6.43934C11.1491 6.22956 11.4164 6.0867 11.7074 6.02882C11.9983 5.97094 12.2999 6.00065 12.574 6.11418C12.8481 6.22771 13.0824 6.41997 13.2472 6.66664C13.412 6.91332 13.5 7.20333 13.5 7.5C13.5 7.89782 13.342 8.27936 13.0607 8.56066C12.7794 8.84196 12.3978 9 12 9Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default IconStatusInfoMedium;
